import h_i18n from "@/utils/Internationalization"

const data = {
    "list": [
        [
            {
                "id": "14",
                "status": "default",
                "position": [1, 5],
                "content": {
                    // "title": {title: "供方自检"},
                    "title": {title:  h_i18n('a08597c1cb4970b650b11163da391ec8') ,help: {show: true, text:'供应商SQM端上传自检报告',line:'up'}},
                    // "title": {title: h_i18n('a08597c1cb4970b650b11163da391ec8')},
                    "content": []
                },
                "next": "15"
            },
            {
                "id": "15",
                "status": "default",
                "position": [1, 6],
                "content": {
                    // "title": {title: "外检审核"},
                    "title": {title: h_i18n('380D4B474AD7015F30367042097828FA'),help: {show: true, text:'角色：外检经理',line:'down'}},
                    // "title": {title: h_i18n('380D4B474AD7015F30367042097828FA')},
                    "content": []
                },
                "next": "16"
            },
            {
                "id": "16",
                "status": "default",
                "position": [1, 7],
                "content": {
                    // "title": {title: "文件结论"},
                    "title": {title:  h_i18n('24180f4b5aa44b93c2eb8e63a39b5607'), help: {show: true, text:'角色：外检负责人',line:'down'}},
                    // "title": {title: h_i18n('24180f4b5aa44b93c2eb8e63a39b5607')},
                    "content": []
                },
                "next": "28"
            }
        ],
        [
            {
                "id": "21",
                "status": "default",
                "position": [2, 1],
                "content": {
                    // "title": {title: h_i18n('3a4766792473ed2fbd9dc0e06018efbd'), help: {show: true, callback: () => {console.log(2, 1, "help")}}},
                    // 样检单下达
                    "title": {title: h_i18n('3a4766792473ed2fbd9dc0e06018efbd'), help: {show: true, text:'说明：<br>来源：PLM<br>时间：半小时取一次',line:'mid',callback: () => {console.log(2, 1, "help")}}},
                    // "title": {title: "样检单下达", help: {show: true, callback: () => {console.log(2, 1, "help")}}},
                    "content": []
                },
                "next": "22"
            },
            {
                "id": "22",
                "status": "default",
                "position": [2, 2],
                "content": {
                    // "title": "检验分工",
                    "title": {title:h_i18n('b4bc694bb6226c9a38fe9574a6542bce'),help: {show: true, text:'操作角色：报验工厂外检负责人',line:'mid'}},
                    // "title": h_i18n('b4bc694bb6226c9a38fe9574a6542bce'),
                    "content": []
                },
                "next": "23"
            },
            {
              "id": "23",
              "status": "default",
              "position": [2, 3],
              "content": {
                  // "title": "标准维护",
                  "title": {title: h_i18n('771287f67a2903174f9b4e1843b41827'),help: {show: true, text:'接收分工任务的外检经理，到专用号依据功能进行标准维护',line:'mid44'}},
                  // "title": h_i18n('771287f67a2903174f9b4e1843b41827'),
                  "content": []
                },
                "next": "20"
              },
            {
              "id": "20",
              "status": "default",
              "position": [2, 4],
              "content": {
                  // "title": "型号经理收样",
                  "title":{title:h_i18n('AC1844AEE0056ADA72B386CA986A7702'),help: {show: true, text:'来源：PDM',line:'mid'}},
                  // "title": h_i18n('AC1844AEE0056ADA72B386CA986A7702'),
                  "content": []
              },
              "next": ["14", "24" ,"31"]
            },
            {
                "id": "24",
                "status": "default",
                "position": [2, 5],
                "content": {
                    // "title": "供方送样",
                    "title": {title: h_i18n('A1C50AE1DAF4561536B680F767B69915'),help: {show: true, text:'以实际供应商送样到货时间为准',line:'up'}},
                    // "title": h_i18n('A1C50AE1DAF4561536B680F767B69915'),
                    "content": []
                },
                "next": "25"
            },
            {
                "id": "25",
                "status": "default",
                "position": [2, 6],
                "content": {
                    // "title": "外检收样",
                    "title": {title:h_i18n('358341109d9d21e43f9478f6d4fcb6c7'),help: {show: true, text:'角色：外检经理',line:'down'}},
                    // "title": h_i18n('358341109d9d21e43f9478f6d4fcb6c7'),
                    "content": []
                },
                "next": "26"
            },
            {
                "id": "26",
                "status": "default",
                "position": [2, 7],
                "content": {
                    // "title": "检验",
                    "title": {title:h_i18n('ccc9d4b32429e48ca0819ac67f398c88'),help: {show: true, text:'角色：外检经理',line:'up'}},
                    // "title": h_i18n('ccc9d4b32429e48ca0819ac67f398c88'),
                    "content": []
                },
                "next": "27"
            },
            {
                "id": "27",
                "status": "default",
                "position": [2, 8],
                "content": {
                    // "title": "物料结论",
                    "title": {title:h_i18n('21aef4b20ab9d79ef20a4e8e56bda209'),help: {show: true, text:'角色：外检负责人',line:'down'}},
                    // "title": h_i18n('21aef4b20ab9d79ef20a4e8e56bda209'),
                    "content": []
                },
                "next": "28"
            },
            {
                "id": "28",
                "status": "default",
                "position": [2, 9],
                "content": {
                    // "title": h_i18n('027c72c524eae3b5d8b7d564e18ffa0d'),
                    // 开发结论
                    "title": {title:h_i18n('027c72c524eae3b5d8b7d564e18ffa0d'),help: {show: true, text:'该节点在PDM进行操作，具体审核人员由PDM流程决定，可咨询PDM系统工程师',line:'mid61'}},
                    // "title": "开发结论",
                    "content": []
                },
                // "next": "29"
            },
            // {
            //     "id": "29",
            //     "status": "default",
            //     "position": [2, 10],
            //     "content": {
            //         // "title": "小批",
            //         "title": h_i18n('8113f5a5cc81c8a266a19b816fcf578b'),
            //         "content": []
            //     }
            // }
        ],
        [
          {
              "id": "31",
              "status": "default",
              "position": [3, 5],
              "content": {
                  // "title": {title: "供方上传"},
                  "title": {title: h_i18n('FB22FB34639C8C382335E2BF3E53F291'), help: {show: true, text:'只有“制版设计稿”状态为"待上传"时，才需要供应商在SQM系统操作；显示黄色才代表需要上传',line:'down'}},
                  // "title": {title: h_i18n('FB22FB34639C8C382335E2BF3E53F291')},
                  "content": []
              },
              "next": "32"
          },
          {
              "id": "32",
              "status": "default",
              "position": [3, 6],
              "content": {
                  // "title": {title: "型号经理审核"},
                  // "title": {title: h_i18n('826326e317a1b6e22df225e69995d82c')},
                  // 型号经理审核
                  "title": {title: h_i18n('826326e317a1b6e22df225e69995d82c'), help: {show: true, text:'角色：型号经理收样节点的型号经理',line:'down'}},
                  "content": []
              },
              "next": "28"
          },
      ],
    ],
    "group": [
        {
            "groupId": 1,
            // 文件审核
            title: h_i18n('79a63d3eb8a197bd61b470fbab1c86ce'),
            // title: "文件审核",
            "group": ["14", "15", "16"],
            color: "#CCBD8C"
        },
        {
          "groupId": 2,
          // 物料审核
          title: h_i18n('B6F0F6558CA5399F3F3DB3BCD0FBFD9E'),
          // title: "物料审核",
          "group": ["24", "25", "26", "27"],
          color: "#5FB6C6"
        },
        {
          "groupId": 3,
          // title: "制版设计稿审核",
          title: h_i18n('4EE0E5AFAB0366966BFF424082065CB7'),
          "group": ["31", "32"],
          color: "#6CBBE9"
        },
      ],
}

export default data
